import { useState } from "react";
import Footer from "../Component/Footer";
import Navbar from "../Component/Navbar";


const G = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { font-size: 16px; }
  body { font-family: 'Inter', sans-serif; color: #111; background: #fff; -webkit-font-smoothing: antialiased; }

  :root {
    --g1: #2e4a1a;
    --g2: #3d6622;
    --g3: #4f7a25;
    --g4: #72b83a;
    --badge-bg: #dff0c6;
    --badge-color: #3a6318;
    --muted: #555;
    --border: #e2e8e0;
    --input-bg: #f0f2ee;
    --dark-bg: #1a2910;
    --dark-card: #1f3313;
    --dark-border: rgba(114,184,58,0.18);
  }

  /* ── HERO ── */
  .hero-section {
    display: flex; align-items: flex-start; justify-content: space-between;
    padding: 72px 120px 80px;
    gap: 40px;
    background: linear-gradient(135deg, #fff 55%, #eef5e6 100%);
    min-height: calc(100vh - 64px);
  }
  .hero-left { flex: 1; max-width: 620px; padding-top: 8px; }

  .badge {
    display: inline-block;
    background: var(--badge-bg); color: var(--badge-color);
    font-family: 'Inter', sans-serif;
    font-size: 13px; font-weight: 600; letter-spacing: 1.4px; text-transform: uppercase;
    padding: 6px 16px; border-radius: 20px; margin-bottom: 28px;
  }

  .hero-h1 {
    font-family: 'Sora', sans-serif;
    font-size: 73px; font-weight: 900; line-height: 1.03; color: #0f0f0f;
    margin-bottom: 24px; letter-spacing: -2.5px;
  }
  .hero-h1 em { font-style: normal; color: var(--g3); }

  .hero-p {
    font-family: 'Inter', sans-serif;
    font-size: 19px; color: #444; line-height: 1.65;
    margin-bottom: 40px; max-width: 520px; font-weight: 400;
  }

  .hero-btns { display: flex; gap: 16px; }
  .btn-dark {
    background: var(--g1); color: #fff;
    font-family: 'Inter', sans-serif;
    font-size: 16px; font-weight: 700; padding: 16px 32px;
    border-radius: 8px; border: none; cursor: pointer; letter-spacing: 0.1px;
  }
  .btn-dark:hover { background: var(--g2); }
  .btn-ghost {
    background: #ebebeb; color: #111;
    font-family: 'Inter', sans-serif;
    font-size: 16px; font-weight: 700; padding: 16px 32px;
    border-radius: 8px; border: none; cursor: pointer;
  }
  .btn-ghost:hover { background: #e0e0e0; }

  /* ── FORM CARD ── */
  .form-card {
    width: 420px; flex-shrink: 0;
    background: #fff; border: 1px solid #dde5d8; border-radius: 16px;
    padding: 36px; box-shadow: 0 8px 40px rgba(0,0,0,0.09);
    margin-top: 8px;
  }
  .fc-title {
    font-family: 'Sora', sans-serif; font-size: 22px; font-weight: 800;
    color: #111; margin-bottom: 24px; letter-spacing: -0.3px;
  }
  .fc-label {
    display: block; font-family: 'Inter', sans-serif;
    font-size: 12px; font-weight: 700; color: #777;
    letter-spacing: 1px; text-transform: uppercase; margin-bottom: 8px;
  }
  .fc-input {
    width: 100%; padding: 14px 16px;
    border: 1.5px solid transparent; border-radius: 8px;
    font-size: 16px; font-family: 'Inter', sans-serif; color: #333;
    margin-bottom: 18px; outline: none;
    background: var(--input-bg);
    transition: border-color 0.2s;
  }
  .fc-input::placeholder { color: #aab; }
  .fc-input:focus { border-color: var(--g4); background: #fff; }
  .fc-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .fc-select {
    width: 100%; padding: 14px 16px;
    border: 1.5px solid transparent; border-radius: 8px;
    font-size: 16px; font-family: 'Inter', sans-serif; color: #555;
    background: var(--input-bg); outline: none; margin-bottom: 22px;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
    background-repeat: no-repeat; background-position: right 14px center;
    background-size: 16px;
  }
  .fc-submit {
    width: 100%; background: var(--g1); color: #fff;
    padding: 16px; border-radius: 8px; border: none;
    font-size: 17px; font-weight: 700; font-family: 'Inter', sans-serif; cursor: pointer;
    letter-spacing: 0.2px;
  }
  .fc-submit:hover { background: var(--g2); }

  /* ── TRUSTED ── */
  .trusted {
    text-align: center; padding: 40px 72px;
    border-top: 1px solid #f0f0f0; border-bottom: 1px solid #f0f0f0;
  }
  .trusted-lbl {
    font-size: 12px; color: #c0c4cc; letter-spacing: 1.6px;
    text-transform: uppercase; margin-bottom: 22px; font-weight: 500;
  }
  .trusted-row { display: flex; align-items: center; justify-content: center; gap: 60px; }
  .trusted-row span {
    font-size: 15px; font-weight: 800; color: #ccc;
    letter-spacing: 1.5px; text-transform: uppercase;
  }

  /* ── SECTIONS ── */
  .sec { max-width: 1200px; margin: 0 auto; padding: 80px 72px; }
  .sec-title {
    font-family: 'Sora', sans-serif; font-size: 40px; font-weight: 800;
    text-align: center; color: #111; margin-bottom: 52px; letter-spacing: -0.8px;
  }

  /* ── FEATURES ── */
  .feat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  .feat-card {
    background: #f8faf6; border: 1px solid #eaf0e4;
    border-radius: 14px; padding: 28px;
  }
  .feat-icon-box {
    width: 44px; height: 44px; background: #d6edba; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    font-size: 20px; margin-bottom: 16px;
  }
  .feat-ttl {
    font-family: 'Sora', sans-serif; font-size: 17px; font-weight: 700;
    color: #111; margin-bottom: 10px;
  }
  .feat-desc {
    font-size: 14px; color: #666; line-height: 1.7; margin-bottom: 20px;
  }
  .feat-preview {
    background: #fff; border: 1px solid #eee; border-radius: 10px; padding: 14px;
  }

  .trip-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 6px 0; border-bottom: 1px solid #f4f4f4;
    font-size: 13px; color: #555;
  }
  .trip-row:last-child { border-bottom: none; }
  .chip { padding: 3px 10px; border-radius: 5px; font-size: 11px; font-weight: 700; }
  .chip-g { background: #e2f5d0; color: #2e7d1a; }
  .chip-y { background: #fef3cd; color: #a16207; }
  .chip-r { background: #fde8e8; color: #be1c1c; }

  .wallet-box { text-align: center; padding: 8px 0 4px; }
  .wallet-lbl { font-size: 11px; color: #aaa; letter-spacing: 0.6px; margin-bottom: 8px; text-transform: uppercase; }
  .wallet-amt { font-family: 'Sora', sans-serif; font-size: 28px; font-weight: 800; color: #111; }
  .wallet-dots { display: flex; gap: 6px; justify-content: center; margin-top: 12px; }
  .wd { width: 7px; height: 7px; border-radius: 50%; background: #ddd; }
  .wd.on { background: var(--g3); }

  .uc-row { display: flex; gap: 8px; flex-wrap: wrap; }
  .uc {
    display: flex; align-items: center; gap: 7px;
    background: #f3f4f6; border-radius: 20px; padding: 5px 12px 5px 5px;
    font-size: 12px; color: #444; font-weight: 500;
  }
  .av {
    width: 24px; height: 24px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 10px; font-weight: 800; color: #fff; flex-shrink: 0;
  }

  /* ── STATS ── */
  .stats-bar {
    background: var(--g1); padding: 60px 0;
    display: flex; justify-content: center; gap: 130px;
  }
  .stat { text-align: center; color: #fff; }
  .stat-n {
    font-family: 'Sora', sans-serif; font-size: 54px; font-weight: 900;
    line-height: 1; margin-bottom: 8px; letter-spacing: -1px;
  }
  .stat-l { font-size: 12px; letter-spacing: 2px; text-transform: uppercase; opacity: 0.65; font-weight: 500; }

  /* ── CITIES ── */
  .cities-sec { max-width: 1200px; margin: 0 auto; padding: 72px 20px; }
  .cities-hdr { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 28px; }
  .cities-ttl { font-family: 'Sora', sans-serif; font-size: 30px; font-weight: 800; color: #111; letter-spacing: -0.4px; }
  .cities-sub { font-size: 15px; color: #9ca3af; margin-top: 5px; }
  .view-all { font-size: 15px; color: var(--g2); font-weight: 600; text-decoration: none; margin-top: 6px; white-space: nowrap; }
  .cities-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px; }
  .city-card { border-radius: 12px; overflow: hidden; height: 250px; position: relative; }
  .city-bg { width: 100%; height: 100%; }
  .city-ov {
    position: absolute; bottom: 0; left: 0; right: 0; padding: 14px 16px;
    background: linear-gradient(transparent, rgba(0,0,0,0.6));
  }
  .city-nm { color: #fff; font-size: 16px; font-weight: 700; font-family: 'Sora', sans-serif; }

  /* ── TESTIMONIALS ── */
  .testi-sec { background: #f8faf6; padding: 80px 0; }
  .testi-inner { max-width: 1200px; margin: 0 auto; padding: 0 72px; }
  .testi-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
  .testi-card { background: #fff; border: 1px solid #e8efe2; border-radius: 14px; padding: 32px; }
  .tq { font-family: 'Sora', sans-serif; font-size: 42px; color: #e0e0e0; line-height: 1; margin-bottom: 12px; }
  .testi-body { font-size: 15px; color: #4b5563; line-height: 1.75; margin-bottom: 22px; }
  .testi-auth { display: flex; align-items: center; gap: 12px; }
  .ta-av {
    width: 40px; height: 40px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 14px; font-weight: 800; color: #fff; flex-shrink: 0;
  }
  .ta-name { font-size: 14px; font-weight: 700; color: #111; }
  .ta-role { font-size: 12px; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.6px; margin-top: 2px; }

  /* ── INDUSTRIES ── */
  .ind-sec { max-width: 1000px; margin: 0 auto; padding: 80px 72px; text-align: center; }
  .ind-sub { font-size: 16px; color: #9ca3af; margin-bottom: 44px; margin-top: 10px; }
  .ind-row { display: flex; justify-content: center; gap: 56px; }
  .ind-item { display: flex; flex-direction: column; align-items: center; gap: 10px; }
  .ind-icon { font-size: 32px; }
  .ind-lbl { font-size: 14px; color: #4b5563; font-weight: 600; }

  /* ── FAQ ── */
  .faq-sec { max-width: 760px; margin: 0 auto; padding: 80px 72px; }
  .faq-item { border-bottom: 1px solid #eee; }
  .faq-q {
    display: flex; justify-content: space-between; align-items: center;
    padding: 20px 0; cursor: pointer;
    font-size: 17px; font-weight: 600; color: #111;
  }
  .faq-icon { font-size: 22px; color: #ccc; line-height: 1; }
  .faq-a { font-size: 15px; color: #666; line-height: 1.75; padding-bottom: 18px; }

  /* ── CTA ── */
  .cta-sec { padding: 48px 72px; }
  .cta-box {
    max-width: 1080px; margin: 0 auto;
    background: var(--g1); border-radius: 20px; padding: 64px 56px; text-align: center;
  }
  .cta-title {
    font-family: 'Sora', sans-serif; font-size: 40px; font-weight: 900;
    color: #fff; margin-bottom: 30px; letter-spacing: -0.6px;
  }
  .cta-btns { display: flex; align-items: center; justify-content: center; gap: 22px; }
  .cta-phone { color: rgba(255,255,255,0.8); font-size: 17px; font-weight: 500; display: flex; align-items: center; gap: 8px; }
  .btn-callback {
    background: var(--g4); color: #fff; border: none;
    padding: 14px 30px; border-radius: 9px; font-size: 16px; font-weight: 700;
    font-family: 'Inter', sans-serif; cursor: pointer;
  }

  /* ── TRIP DETAILS DARK SECTION ── */
  .trip-dark-sec {
    background: var(--dark-bg);
    padding: 80px 72px;
  }
  .dark-sec-header {
    max-width: 1200px; margin: 0 auto 40px;
  }
  .dark-sec-badge {
    display: inline-block; background: rgba(114,184,58,0.15); color: var(--g4);
    font-size: 11px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase;
    padding: 5px 14px; border-radius: 20px; margin-bottom: 14px;
  }
  .dark-sec-title {
    font-family: 'Sora', sans-serif; font-size: 30px; font-weight: 800;
    color: #fff; margin-bottom: 8px; letter-spacing: -0.4px;
  }
  .dark-sec-sub { font-size: 15px; color: rgba(255,255,255,0.45); line-height: 1.6; }

  .trip-detail-card {
    background: #fff; border-radius: 16px; padding: 28px 28px 8px;
    max-width: 1200px; margin: 0 auto;
    box-shadow: 0 24px 72px rgba(0,0,0,0.4);
  }
  .tdc-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
  .tdc-title {
    font-family: 'Sora', sans-serif; font-size: 18px; font-weight: 800; color: #111;
    position: relative; padding-bottom: 6px;
  }
  .tdc-title::after {
    content: ''; position: absolute; bottom: 0; left: 0;
    width: 100%; height: 3px; background: var(--g3); border-radius: 2px;
  }
  .tdc-export { font-size: 14px; font-weight: 700; color: var(--g3); cursor: pointer; display: flex; align-items: center; gap: 6px; }

  .tdtable { width: 100%; border-collapse: collapse; }
  .tdtable th {
    text-align: left; font-size: 11px; font-weight: 800; color: #aaa;
    letter-spacing: 1.2px; text-transform: uppercase;
    padding: 10px 14px; background: #f8f9f7;
  }
  .tdtable td { padding: 15px 14px; font-size: 14px; color: #333; border-bottom: 1px solid #f2f2f2; vertical-align: middle; }
  .tdtable tr.expanded-detail td { background: #f5faf0; border-bottom: 1px solid #e8f0e0; }
  .tdtable tr:last-child td { border-bottom: none; }

  .expand-circle {
    width: 30px; height: 30px; border-radius: 50%; background: #f0f2ee;
    border: none; display: inline-flex; align-items: center; justify-content: center;
    font-size: 13px; color: #666; cursor: pointer; font-weight: 700;
  }
  .sc-completed { background: #d6f5d0; color: #1a7a1a; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.5px; }
  .sc-progress { background: #fef3cd; color: #a16207; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.5px; }

  .route-expand { display: flex; gap: 40px; padding: 4px 0 12px; }
  .route-col { flex: 0 0 auto; }
  .rp { display: flex; align-items: flex-start; gap: 10px; }
  .rdot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }
  .rline { display: flex; flex-direction: column; gap: 3px; margin: 4px 0 4px 4px; }
  .rdash { width: 2px; height: 5px; background: #ccc; border-radius: 1px; }
  .rlbl { font-size: 12px; font-weight: 700; color: #777; }
  .raddr { font-size: 13px; color: #333; margin-top: 2px; max-width: 300px; line-height: 1.4; }
  .info-col { }
  .ilbl { font-size: 10px; font-weight: 700; color: #bbb; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 4px; margin-top: 14px; }
  .ilbl:first-child { margin-top: 0; }
  .ival { font-size: 14px; font-weight: 600; color: #333; }

  /* ── WALLET + MULTI-USER DARK SECTION ── */
  .wmu-dark-sec {
    background: var(--dark-bg);
    padding: 0 72px 80px;
  }
  .wmu-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 32px;
    max-width: 1200px; margin: 0 auto;
  }
  .wmu-block-title {
    font-family: 'Sora', sans-serif; font-size: 22px; font-weight: 800;
    color: #fff; margin-bottom: 6px; letter-spacing: -0.3px;
  }
  .wmu-block-sub { font-size: 14px; color: rgba(255,255,255,0.42); margin-bottom: 20px; line-height: 1.5; }
  .wmu-white-card {
    background: #fff; border-radius: 16px; padding: 28px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.38);
  }

  /* wallet internals */
  .wallet2-inner { display: flex; align-items: center; gap: 20px; margin-bottom: 18px; }
  .wallet2-icon {
    width: 68px; height: 68px; border-radius: 50%;
    background: linear-gradient(135deg, #c8dbb0 0%, #eef5e6 100%);
    display: flex; align-items: center; justify-content: center;
    font-size: 30px; flex-shrink: 0;
  }
  .wallet2-meta {}
  .wallet2-lbl { font-size: 10px; font-weight: 700; letter-spacing: 1.5px; color: #999; text-transform: uppercase; margin-bottom: 6px; }
  .wallet2-amt { font-family: 'Sora', sans-serif; font-size: 36px; font-weight: 900; color: #111; }
  .wallet2-status { font-size: 13px; font-weight: 800; color: var(--g3); letter-spacing: 0.5px; margin-bottom: 4px; }
  .wallet2-hint { font-size: 13px; color: #888; margin-bottom: 22px; }
  .recharge-btn2 {
   background: var(--g1); color: #fff;
    font-family: 'Inter', sans-serif;
    font-size: 16px; font-weight: 700; padding: 16px 32px;
    border-radius: 8px; border: none; cursor: pointer; letter-spacing: 0.1px;
  }


  /* employee table internals */
  .emp-hdr { display: flex; justify-content: space-between; align-items: center; margin-bottom: 18px; }
  .emp-card-title {
    font-family: 'Sora', sans-serif; font-size: 17px; font-weight: 800; color: #111;
    position: relative; padding-bottom: 6px;
  }
  .emp-card-title::after {
    content: ''; position: absolute; bottom: 0; left: 0;
    width: 100%; height: 3px; background: var(--g3); border-radius: 2px;
  }
  .add-emp { font-size: 14px; font-weight: 700; color: #1a56db; cursor: pointer; }
  .emptable { width: 100%; border-collapse: collapse; }
  .emptable th { font-size: 10px; font-weight: 800; color: #aaa; letter-spacing: 1.2px; text-transform: uppercase; padding: 6px 10px; text-align: left; }
  .emptable td { padding: 13px 10px; font-size: 13px; color: #333; border-bottom: 1px solid #f4f4f4; }
  .emptable tr:last-child td { border-bottom: none; }
  .toggle-pill {
    display: inline-block; width: 38px; height: 21px; background: var(--g3);
    border-radius: 11px; position: relative; cursor: pointer;
  }
  .toggle-pill::after {
    content: ''; position: absolute; top: 3px; right: 3px;
    width: 15px; height: 15px; background: #fff; border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
`;

const FAQS = [
  { q: "How do you track shipment security?", a: "We use real-time GPS tracking, tamper-proof seals, and 24/7 monitoring for all shipments across our network." },
  { q: "What is the prepaid wallet policy?", a: "Enterprises load funds into a prepaid wallet; disbursements happen automatically upon trip completion with full audit logs." },
  { q: "Can we integrate with our existing ERP?", a: "Yes — imTransporter provides REST APIs and pre-built connectors for SAP, Oracle, Microsoft Dynamics, and more." },
  { q: "What is the turnaround time for enterprise setup?", a: "Most enterprise onboardings complete within 3–5 business days including API integration and user training." },
];

const CITY_GRADS = [
  "linear-gradient(135deg,#6b48ff,#9b59b6)",
  "linear-gradient(135deg,#e91e8c,#ff6b6b)",
  "linear-gradient(135deg,#00b4d8,#0077b6)",
  "linear-gradient(135deg,#f7c948,#f4845f)",
];

const TRIPS = [
  { id: "T-001", date: "05/9/25", name: "Ramesh", vehicle: "Eicher Pro", status: "progress", amount: "₹700" },
  { id: "T-002", date: "12/9/25", name: "Pravin", vehicle: "3-Wheeler", status: "completed", amount: "₹733" },
  { id: "T-003", date: "17/9/25", name: "Sanchit", vehicle: "Tata Ace", status: "completed", amount: "₹1800" },
];

const EMPLOYEES = [
  { name: "Ramesh", phone: "(+91) 78659438", email: "ramesh.mehta@gmail.com" },
  { name: "Pravin", phone: "(+91) 98786584", email: "pravin.sharma@gmail.com" },
  { name: "Sanchit", phone: "(+91) 87560954", email: "sanchit.singh@gmail.com" },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState(null);
  const [expandedTrip, setExpandedTrip] = useState("T-002");

  return (
    <>
      <style>{G}</style>

      {/* NAVBAR */}
      <Navbar />

      {/* HERO */}
      <div className="hero-section">
        <div className="hero-left">
          <span className="badge">Logistic Excellence</span>
          <h1 className="hero-h1">
            Reliable Goods<br />Transportation<br />Services, <em>truly<br />controlled by you</em>
          </h1>
          <p className="hero-p">
            Experience the next generation of enterprise logistics. Transparent pricing,
            real-time fleet visibility, and a unified platform built for high-scale operations.
          </p>
          <div className="hero-btns">
            <button className="btn-dark">Explore Services</button>
            <button className="btn-ghost">How it Works</button>
          </div>
        </div>

        <div className="form-card">
          <div className="fc-title">Fill Out For More Details</div>
          <label className="fc-label">Company Name</label>
          <input className="fc-input" placeholder="Acme Logistics Co." />
          <div className="fc-row">
            <div>
              <label className="fc-label">Work Email</label>
              <input className="fc-input" placeholder="john@acme.com" />
            </div>
            <div>
              <label className="fc-label">Phone</label>
              <input className="fc-input" placeholder="+1 234 567 890" />
            </div>
          </div>
          <label className="fc-label">Monthly Shipment Volume</label>
          <select className="fc-select">
            <option value="">Select range</option>
            <option>1–50</option>
            <option>50–200</option>
            <option>200+</option>
          </select>
          <button className="fc-submit">Submit Request</button>
        </div>
      </div>

      {/* TRUSTED */}
      <div className="trusted">
        <div className="trusted-lbl">Trusted by 10,000+ Enterprises Globally</div>
        <div className="trusted-row">
          {["GLOBALMART", "TECHFLOW", "AMAZONAS", "FRETEX", "LOGIX"].map(l => <span key={l}>{l}</span>)}
        </div>
      </div>

      {/* FEATURES */}
      <div className="sec">
        <h2 className="sec-title">Everything you need for smart logistics</h2>
        <div className="feat-grid">
          <div className="feat-card">
            <div className="feat-icon-box">📋</div>
            <div className="feat-ttl">Unified Trip Details</div>
            <div className="feat-desc">Access all shipment data, route history, and driver performance in a single high-fidelity table view.</div>
            <div className="feat-preview">
              {[["BLR-001", "In Transit", "g"], ["DEL-042", "Delivered", "y"], ["MUM-017", "Delayed", "r"]].map(([id, s, c]) => (
                <div className="trip-row" key={id}><span>{id}</span><span className={`chip chip-${c}`}>{s}</span></div>
              ))}
            </div>
          </div>
          <div className="feat-card">
            <div className="feat-icon-box">💳</div>
            <div className="feat-ttl">Payments through Prepaid Wallet</div>
            <div className="feat-desc">Seamlessly manage disbursements and driver settlements via our integrated enterprise wallet.</div>
            <div className="feat-preview">
              <div className="wallet-box">
                <div className="wallet-lbl">Wallet Balance</div>
                <div className="wallet-amt">$142,850.00</div>
                <div className="wallet-dots"><div className="wd on" /><div className="wd" /><div className="wd" /></div>
              </div>
            </div>
          </div>
          <div className="feat-card">
            <div className="feat-icon-box">👥</div>
            <div className="feat-ttl">Multi-User Access</div>
            <div className="feat-desc">Role-based permissions for dispatchers, accountants, and regional managers to ensure security.</div>
            <div className="feat-preview">
              <div className="uc-row">
                {[["D", "#3d6622", "Dispatcher"], ["A", "#c0392b", "Accountant"], ["R", "#2574a9", "Regional Mgr"]].map(([l, c, r]) => (
                  <div className="uc" key={r}><div className="av" style={{ background: c }}>{l}</div>{r}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STATS */}
      {/* <div className="stats-bar">
        {[["21+", "Major Cities Covered"], ["7.5L+", "Driver Partners"], ["10k+", "Enterprise Clients"]].map(([n, l]) => (
          <div className="stat" key={l}><div className="stat-n">{n}</div><div className="stat-l">{l}</div></div>
        ))}
      </div> */}

      {/* ── TRIP DETAILS DARK SECTION ── */}
      <div className="trip-dark-sec">
        <div className="dark-sec-header">
          <span className="dark-sec-badge">Trip Management</span>
          <div className="dark-sec-title">Unified Trip Details</div>
          <div className="dark-sec-sub">Check all your goods transportation trip information in the city.</div>
        </div>

        <div className="trip-detail-card">
          <div className="tdc-top">
            <div className="tdc-title">Trip Details</div>
            <div className="tdc-export">↗ Export Trip Details</div>
          </div>
          <table className="tdtable">
            <thead>
              <tr>
                <th style={{ width: 40 }}></th>
                <th>DATE</th>
                <th>NAME</th>
                <th>VEHICLE</th>
                <th>STATUS</th>
                <th>AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {TRIPS.map(trip => (
                <>
                  <tr key={trip.id}>
                    <td>
                      <button
                        className="expand-circle"
                        onClick={() => setExpandedTrip(expandedTrip === trip.id ? null : trip.id)}
                      >
                        {expandedTrip === trip.id ? "∧" : "∨"}
                      </button>
                    </td>
                    <td>{trip.date}</td>
                    <td style={{ fontWeight: 600 }}>{trip.name}</td>
                    <td>{trip.vehicle}</td>
                    <td>
                      <span className={trip.status === "completed" ? "sc-completed" : "sc-progress"}>
                        {trip.status === "completed" ? "COMPLETED" : "IN PROGRESS"}
                      </span>
                    </td>
                    <td style={{ fontWeight: 700 }}>{trip.amount}</td>
                  </tr>
                  {expandedTrip === trip.id && (
                    <tr className="expanded-detail" key={`${trip.id}-detail`}>
                      <td colSpan={6}>
                        <div className="route-expand">
                          <div className="route-col">
                            <div className="rp">
                              <div className="rdot" style={{ background: "#22c55e" }} />
                              <div>
                                <div className="rlbl">Pickup · 11:15 AM</div>
                                <div className="raddr">Ganesh Nagar, Kalewadi, Pune, Maharashtra 411017, India</div>
                              </div>
                            </div>
                            <div className="rline">
                              <div className="rdash" /><div className="rdash" /><div className="rdash" />
                            </div>
                            <div className="rp">
                              <div className="rdot" style={{ background: "#ef4444" }} />
                              <div>
                                <div className="rlbl">Drop Off · 12:25 PM</div>
                                <div className="raddr">Gandharv Nagar, Moshi, Pune, Maharashtra 411022, India</div>
                              </div>
                            </div>
                          </div>
                          <div className="info-col">
                            <div className="ilbl">Receiver Details</div>
                            <div className="ival">Sharad Krishnan</div>
                            <div className="ilbl">Distance</div>
                            <div className="ival">13 KMS</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── WALLET + MULTI-USER DARK SECTION ── */}
      <div className="wmu-dark-sec">
        <div className="wmu-grid">
          {/* Wallet */}
          <div>
            <div className="wmu-block-title">Complete Clarity and Control</div>
            <div className="wmu-block-sub">Monitor wallet usage with full visibility.</div>
            <div className="wmu-white-card">
              <div className="wallet2-inner">
                <div className="wallet2-icon">💳</div>
                <div className="wallet2-meta">
                  <div className="wallet2-lbl">Current Wallet Balance</div>
                  <div className="wallet2-amt">₹13,400</div>
                </div>
              </div>
              <div className="wallet2-status">✔ Sufficient Balance</div>
              <div className="wallet2-hint">But a little extra recharge never hurts!</div>
              <button className="recharge-btn2">Recharge Wallet</button>
            </div>
          </div>

          {/* Multi-User */}
          <div>
            <div className="wmu-block-title">Multi-User Access</div>
            <div className="wmu-block-sub">Add, remove, activate, or deactivate users to maintain unified logistics operations.</div>
            <div className="wmu-white-card">
              <div className="emp-hdr">
                <div className="emp-card-title">Employee Details</div>
                {/* <div className="add-emp">+ Add Employee</div> */}
              </div>
              <table className="emptable">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>PHONE NUMBER</th>
                    <th>EMAIL ADDRESS</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {EMPLOYEES.map(emp => (
                    <tr key={emp.name}>
                      <td style={{ fontWeight: 600 }}>{emp.name}</td>
                      <td>{emp.phone}</td>
                      <td>{emp.email}</td>
                      <td><div className="toggle-pill" /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* CITIES */}
      <div className="cities-sec">
        <div className="cities-hdr">
          <div>
            <div className="cities-ttl">Operating across the nation</div>
            <div className="cities-sub">Scale your business with our expansive metropolitan network.</div>
          </div>
          {/* <a href="#" className="view-all">View all cities →</a> */}
        </div>
        <div className="cities-grid">
          {[
            { city: "Delhi", img: "/images/delhi.png" },
            { city: "Mumbai", img: "/images/mumbai.png" },
            { city: "Hyderabad", img: "/images/hydrabad.png" },
            { city: "Bangalore", img: "/images/bangalore.png" },
            { city: "Kolkata", img: "/images/kolkata.png" },
          ].map(({ city, img }) => (
            <div className="city-card" key={city}>
              <img
                src={img}
                alt={city}
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
              <div className="city-ov"><div className="city-nm">{city}</div></div>
            </div>
          ))}
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="testi-sec">
        <div className="testi-inner">
          <h2 className="sec-title">Voice of Leadership</h2>
          <div className="testi-grid">
            {[
              { body: "imTransporter has revolutionized our last-mile delivery network. The transparency in pricing and the dashboard interface is unlike anything we've used in 20 years of logistics.", name: "Mark Stevenson", role: "Logistics Manager, Globalmart", av: "MS", c: "#4a7c28" },
              { body: "Scaling to 10 new cities in 6 months was only possible because of imTransporter's robust API and reliable driver network. They are a true strategic partner, not just a vendor.", name: "Sarah Choi", role: "CTO, TechFlow Inc.", av: "SC", c: "#2574a9" },
            ].map((t, i) => (
              <div className="testi-card" key={i}>
                <div className="tq">"</div>
                <p className="testi-body">{t.body}</p>
                <div className="testi-auth">
                  <div className="ta-av" style={{ background: t.c }}>{t.av}</div>
                  <div><div className="ta-name">{t.name}</div><div className="ta-role">{t.role}</div></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* INDUSTRIES */}
      <div className="ind-sec">
        <h2 className="sec-title">Tailored for every industry</h2>
        <p className="ind-sub">Specialized handling and transit protocols for diverse business needs.</p>
        <div className="ind-row">
          {[["📺", "Electronics"], ["🍽️", "Food & Bev"], ["🏗️", "Construction"], ["🏥", "Healthcare"], ["👗", "Fashion"], ["🛒", "E-commerce"]].map(([ic, lb]) => (
            <div className="ind-item" key={lb}><div className="ind-icon">{ic}</div><div className="ind-lbl">{lb}</div></div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div className="faq-sec">
        <h2 className="sec-title">Frequently Asked Questions</h2>
        {FAQS.map((f, i) => (
          <div className="faq-item" key={i}>
            <div className="faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
              <span>{f.q}</span><span className="faq-icon">{openFaq === i ? "−" : "+"}</span>
            </div>
            {openFaq === i && <div className="faq-a">{f.a}</div>}
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="cta-sec">
        <div className="cta-box">
          <div className="cta-title">Ready to transform your logistics?</div>
          <div className="cta-btns">
            <div className="cta-phone">📞 +1 (800) TRANS-LOG</div>
            <button className="btn-callback">Request Callback</button>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <Footer />
    </>
  );
}